import React, {Fragment,useState} from 'react'
import { Link } from 'react-router-dom'


//components
import ThemeMainMenu from './ThemeMainMenu'
import SearchModal from '../search-modal/SearchModal';
import SideBar from '../sidebar/SideBar';
import MobileMenu from './MobileMenu'

const ThemeMenuThree = () => {
    const [sticky, setSticky] = useState(false);
    const [modalIsopen, setOpen] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const [menu, setMenu] = useState("")

    const openModal =()=>{
        setOpen(true);
    }
    const closeModal =()=>{
        setOpen(false);
    }
    const openSidebar =()=>{
        setShowSidebar(true)
    }
    const closeSidebar =()=>{
        setShowSidebar(false)
    }
    const showMobilemenu =()=>{
        setMenu('show')
    }
    const hideMobilemenu =()=>{
        setMenu()
    }

    const stickyMenu = ()=>{
        if(window.scrollY >= 60){
            setSticky(true);
        } else{
            setSticky(false);
        }
    };
    window.addEventListener('scroll', stickyMenu);
    return (
        <Fragment>
            <SearchModal isOpen={modalIsopen} onClick={closeModal}/>
            <SideBar onClick={closeSidebar} value={showSidebar} />
            <header className="theme-main-menu theme-menu-three pt-25">
                <div className="top-header pb-25">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-4 col-lg-3 text-start d-none d-lg-inline-block">
                                <div className="logo-area">
                                    <Link to="/"><img src="assets/img/logo/header-logo-1.png" style={{ width: '35%' }} alt="Header-logo"/></Link>
                                </div>
                            </div>
                            <div className="col-xl-8 col-lg-9">
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </Fragment>
    )
}

export default ThemeMenuThree